import { useMemo } from 'preact/hooks';
import { marked } from 'marked';
import './MarkdownRenderer.css';

interface MarkdownRendererProps {
  content: string;
  size?: string;
}

export function MarkdownRenderer({ content, size = 'sm' }: MarkdownRendererProps) {
  const htmlContent = useMemo(() => {
    // Configure marked options for better rendering
    marked.setOptions({
      breaks: true, // Convert \n to <br>
      gfm: true, // GitHub Flavored Markdown
    });

    // Parse markdown to HTML
    return marked.parse(content);
  }, [content]);

  return (
    <div
      className="markdown"
      style={{
        fontSize: size === 'sm' ? '14px' : size === 'xs' ? '12px' : '16px',
      }}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
}